import React from 'react';
import { hashHistory } from 'react-router';
import { Alert, Button, Table } from 'react-bootstrap';
import '../css/table.css';
import '../css/main.css';
import { authContext } from '../AzureAd';

export default class MaintenanceRefineCardsComponent extends React.Component {

	// constructor(props) {
	// 	super(props);
	// }

	previousPage() {
		//MaintenanceRefineContainer
		hashHistory.push("/refineCases");
	}

	hideAlert() {
		return this.props.alert.get('style') == null;
	}

	componentDidMount() {
	}

	componentWillMount() {
		this.props.findRefinableMCards(this.props.request.get('target'));
	}

	modifyCard(cardPk) {
		this.props.assignModifyingTarget(cardPk);
		hashHistory.push("/modifyMCard");
	}

	viewPhotos(cardId) {
		this.props.findPhotos(cardId);
		this.props.changePhotoListPreviousPage('/refineCards');
		hashHistory.push("/photoList");
	}

	showPhotoBlk(cardId, category) {
		this.props.changeCategory(category);
		this.props.reloadCheckCard(cardId);
		this.props.reloadMaintenanceCase(this.props.request.get('target'));
		this.props.changeCheckCardPreviousPage("/refineCards");
		this.props.findPhotosByItemType(cardId, category);
		hashHistory.push("/takePhoto");
	}

	render() {

		let cardStatus = function (statusKey) {
			switch (statusKey) {
				case 'COMPLETED':
					return '尚未確認';

				case 'MODIFIED':
					return '修改清點中';

				case 'REFINED':
					return '已確認';

				case 'AUDITED':
					return '已確認';

				default:
					return "";
			}
		}

		let highlight = function (statusKey) {
			switch (statusKey) {
				case 'COMPLETED':
					return {
						textAlign: "center",
						backgroundColor: "#FFBFBF",
					};
				case 'MODIFIED':
					return {
						textAlign: "center",
						backgroundColor: "#FFE8BF",
					};
				case 'REFINED':
					return {
						textAlign: "center",
						backgroundColor: "#96FF96",
					};
				case 'AUDITED':
					return {
						textAlign: "center",
						backgroundColor: "#96FF96",
					};
				default:
					return {};
			}
		}

		let highlightClassName = function (statusKey) {
			switch (statusKey) {
				case 'COMPLETED':
					return "highlight-red";
				case 'MODIFIED':
					return "highlight-brown";
				case 'REFINED':
					return "highlight-green";
				case 'AUDITED':
					return "highlight-green";
				default:
					return '';
			}
		}

		let sortIcon = (field) => {
			let orders = this.props.request.get('sortOrders');
			let asc = orders.get(field).get('asc');
			let icon;
			if (asc === undefined || orders.get('orderby') !== field) {
				icon = 'sort.svg';
			} else {
				icon = asc ? 'sort-up.svg' : 'sort-dw.svg';
			}

			return <a
				onClick={(event) => {
					this.props.sortCards(
						this.props.response.get('cards'),
						this.props.request.get('sortOrders').get(field));
				}
				}>
				<img src={icon} height="18" width="18" className='sort' alt="" />
			</a>
		}

		let alignCenter = {
			textAlign: "center",
			verticalAlign: "middle"
		}

		let roles = this.props.roles.toJS();
		let showCaseFixing = (roles.includes("ROLE_MAINTENANCE_CASE_FIXING"));

		return (
			<div>
				<h4><span hidden>MaintenanceRefineCardsComponent </span>
					作業開工確認&nbsp;&gt;&gt;&nbsp;維修表確認修改&nbsp;
					<a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
				</h4>
				<Alert
					bsStyle={this.props.alert.get('style')}
					hidden={this.props.alert.get('style') == null}>
					{this.props.alert.get('message')}
				</Alert>
				<table className="main">
					<tbody>
						<tr>
							<th width="14%">訂單編號</th>
							<td width="22%" className={"highlight"} style={{ textAlign: "center" }}>{this.props.request.get("mcase").orderId} {this.props.request.get("mcase").note}</td>
							<th width="14%">客戶名稱</th>
							<td width="22%">{this.props.request.get("mcase").customer.customerName}</td>
							<th width="14%">建立時間</th>
							<td width="14%">{new Date(this.props.request.get("mcase").createTime).toLocaleDateString()}</td>
						</tr>
					</tbody>
				</table>
				<br />
				<Table striped bordered condensed hover>
					<thead>
						<tr>
							<th>序號 {sortIcon("code")}</th>
							<th>單位 {sortIcon("unit")}</th>
							<th>使用者 {sortIcon("owner")}</th>
							<th>建立時間</th>
							<th>狀態 {sortIcon("status")}</th>
							{showCaseFixing && <th>修改 {sortIcon("status")}</th>}
							{showCaseFixing && <th>確認 {sortIcon("status")}</th>}
							<th>照相(衣)</th>
							<th>照相(褲)</th>
							<th>相片</th>
						</tr>
					</thead>
					<tbody>
						{
							this.props.response.get('cards').map(
								(item, index) =>
									<tr key={index}>
										<td>{item.code}</td>
										<td>{item.organization}{item.unit}</td>
										<td>{item.owner}</td>
										<td>{new Date(item.createTime).toLocaleDateString()}</td>
										<td style={highlight(item.status)} className={highlightClassName(item.status)}>{cardStatus(item.status)}</td>
										{showCaseFixing &&
											<td style={alignCenter}>
												<Button bsStyle="info" onClick={(event) => {
													this.modifyCard(item.id);
												}}
												>
													{(item.status === 'REFINED' || item.status === 'AUDITED') ? "明細..." : "修改..."}

												</Button>
											</td>
										}
										{showCaseFixing &&
											<td style={alignCenter}>
												<Button bsStyle="success" onClick={(event) => {
													this.props.refineMCard(
														item.id,
														item.maintenanceCaseId,
														authContext.getCachedUser().userName);
												}}
													disabled={item.status === 'REFINED' || item.status === 'AUDITED'}
												>
													確認
												</Button>
											</td>
										}
										<td style={alignCenter}>
											<Button onClick={(e) => { this.showPhotoBlk(item.id, 0); }} >
												<img title="takePhoto" alt='takePhoto' src='camera.svg' height="22" width="22" />
											</Button>
										</td>
										<td style={alignCenter}>
											<Button onClick={(e) => { this.showPhotoBlk(item.id, 1); }} >
												<img title="takePhoto" alt='takePhoto' src='camera.svg' height="22" width="22" />
											</Button>
										</td>
										<td style={alignCenter}>
											<Button onClick={(e) => { this.viewPhotos(item.id); }} >
												<img title="photos" alt='photos' src='gallery.svg' height="22" width="24" />
											</Button>
										</td>
									</tr>
							)
						}
					</tbody>
				</Table>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceRefineCardsComponent.jsx